// I tried to do this with an IntersectionObserver at first
// and had little luck. If anyone has a working solution,
// send it over!
import throttle from '@app/lib/helpers/throttle';

function eventListener(callback) {
    let previousY = 0;
    return function () {
        if (window.scrollY > previousY || window.scrollY < 110) {
            callback('down');
        } else {
            callback('up');
        }
        previousY = window.scrollY;
    };
}

export function addScrollDirectionListener(element, callback, delay = 250) {
    const listener = throttle(eventListener(callback), delay);
    element.addEventListener('scroll', listener, { passive: true });
}

export function removeScrollDirectionListener(element, callback, delay = 250) {
    const listener = throttle(eventListener(callback), delay);
    element.removeEventListener('scroll', listener);
}
